import adminMiddleware from "@/components/access/admin/ducks/middleware"
import userMiddleware from "@/components/access/ducks/middleware"
import internalMiddleware from "@/components/access/internal/ducks/middleware"

export default [userMiddleware, internalMiddleware, adminMiddleware]
